import { useRef, useState } from 'react';
import { audio } from '../core/audio';
import { recordSkill } from '../core/storage';

const CORRECT = ['correct1', 'correct2', 'correct3'];

export function useActivity(activity, onComplete) {
  const [wrong, setWrong] = useState(0);
  const [state, setState] = useState('playing'); // playing | correct
  const stats = useRef({ attempts: 0, hints: 0 });
  const busy = useRef(false);

  const answer = async (isCorrect) => {
    if (state === 'correct') return;
    // A CORRECT answer must never be swallowed. `busy` stays true for the whole
    // of an awaited retry line (~2s), and in a drag game the child can place the
    // right object inside that window — the object is consumed, the round latches
    // as finished, and answer(true) used to return as a no-op, hanging the round
    // for ever with no way out but Home. Only wrong answers wait their turn.
    if (busy.current && !isCorrect) return;
    if (isCorrect) audio.stopVoice();   // resolves the pending retry promise
    busy.current = true;
    stats.current.attempts += 1;
    if (isCorrect) {
      setState('correct');
      audio.playSfx('correct');
      recordSkill(activity.skill, true);
      window.dispatchEvent(new CustomEvent('pp-answer', { detail: { correct: true } }));
      await audio.playVoice(CORRECT[Math.floor(Math.random() * CORRECT.length)]);
      setTimeout(() => {
        audio.playSfx('transition');
        onComplete({ id: activity.id, correct: true, attempts: stats.current.attempts, hints: stats.current.hints, skill: activity.skill });
      }, 700);
    } else {
      const w = wrong + 1;
      setWrong(w);
      recordSkill(activity.skill, false);
      window.dispatchEvent(new CustomEvent('pp-answer', { detail: { correct: false } }));
      audio.playSfx('retry');
      if (w >= 2) { stats.current.hints += 1; await audio.playVoice('hint'); }
      else await audio.playVoice(w === 1 ? 'retry1' : 'retry2');
      busy.current = false;
    }
  };

  return { wrong, state, answer, showHint: wrong >= 2, demonstrate: wrong >= 3 };
}
